interface ComponentProps {
    isModalOpen: boolean;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    children?: React.ReactNode;
}

const Modal: React.FC<ComponentProps> = ({ isModalOpen, setIsModalOpen, children }) => {

    return (
        isModalOpen ? (
            <div className="fixed inset-0 flex items-center justify-center">
                <div className='absolute inset-0 bg-black/20 pointer-events-none' />

                <div className="relative bg-white p-6 rounded-lg shadow-lg w-1/3 z-10">
                    <button
                        onClick={() => setIsModalOpen(false)}
                        className="absolute top-2 right-4 text-xl font-bold text-gray-600 hover:text-gray-900 hover:cursor-pointer"
                    >
                        &times;
                    </button>
                    {children}
                </div>
            </div>
        ) : null
    )
}

export default Modal;